// extracted by mini-css-extract-plugin
module.exports = {"container":"Prices_container__383Xg","item":"Prices_item__1MQvB","selected":"Prices_selected__3tR9Z","arrow":"Prices_arrow__pN8V_"};